import i18next from "i18next";
import { TaxationEstimate } from "@rentablo/api/apiv1";

export const generateCSVData = (taxationEstimates: TaxationEstimate[] = []) => {
  const table: (string | number | undefined)[][] = [
    [
      "ISIN",
      "Name",
      "Teilfreistellung Kategorie",
      "Teilfreistellung in Prozent",
      "Bestandsprovision",
      "Provisionseinbehalt",
      "Erstatteter Betrag",
      "Steuerrelevanter Betrag",
    ],
  ];

  taxationEstimates.forEach((taxationEstimate) => {
    table.push([
      taxationEstimate.isin,
      taxationEstimate.name,
      i18next.t(
        `domains.cashback.dashboard.taxHelper.categories.${taxationEstimate.taxationCategory}`
      ) as string,
      taxationEstimate.taxationExemptInPercent,
      taxationEstimate.portfolioCommission,
      taxationEstimate.costPortion,
      (taxationEstimate.portfolioCommission || 0) -
        (taxationEstimate.costPortion || 0),
      taxationEstimate.taxationRelevantAmount,
    ]);
  });

  return table;
};
